<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Carousel from '$lib/carousel.svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import CarouselNavigationArrows from '$lib/carouselNavigationArrows.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<{
			cards: Array<ISbStoryData>;
		}>['content'];
	}

	let { content }: Props = $props();

	let embla = $state<EmblaCarouselType>();
	let active = $state(0);

	function next() {
		if (embla) {
			embla.scrollNext();
		}
	}

	function previous() {
		if (embla) {
			embla.scrollPrev();
		}
	}
</script>

<section use:editable={content} class="w-screen overflow-x-hidden text-brown-2">
	<PageGrid>
		<div class="col-span-full">
			{#if content.cards.length < 5 || !device.data.isDesktop}
				<div class="flex flex-col gap-x-[18px] gap-y-7 lg:flex-row">
					{#each content.cards as quote}
						<div class="w-full flex-1">
							<Blok content={quote} />
						</div>
					{/each}
				</div>
			{:else}
				<Carousel
					bind:embla
					bind:currentIndex={active}
					align="start"
					overflow
					class="flex gap-x-[18px]"
				>
					{#each content.cards as quote}
						<div class="flex-none basis-[24%]">
							<Blok content={quote} />
						</div>
					{/each}
				</Carousel>
				<div class="my-11 max-lg:hidden">
					<CarouselNavigationArrows
						hasNext={active < content.cards.length - 4}
						hasPrev={active !== 0}
						onnext={next}
						onprevious={previous}
					/>
				</div>
			{/if}
		</div>
	</PageGrid>
</section>
